import { render, staticRenderFns } from "./Matrix1.vue?vue&type=template&id=42b8ff0c&scoped=true"
import script from "./Matrix1.vue?vue&type=script&lang=js"
export * from "./Matrix1.vue?vue&type=script&lang=js"
import style0 from "./Matrix1.vue?vue&type=style&index=0&id=42b8ff0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8ff0c",
  null
  
)

export default component.exports